const SERVICE_CHANNEL_MENU_ITEM_ID = 1
const COOKIES_MENU_ITEM_ID = 2
const DISABLE_BROWSER_COOKIES_MENU_ITEM_ID = 5

const MENU_ITEMS_IDS = {
  SERVICE_CHANNEL_MENU_ITEM_ID,
  COOKIES_MENU_ITEM_ID,
  DISABLE_BROWSER_COOKIES_MENU_ITEM_ID,
}

const COOKIE_MENU_ITEMS_OBJECT = [
  {
    id: MENU_ITEMS_IDS.COOKIES_MENU_ITEM_ID,
    title: 'Cookies',
    translateKey: 'menu.cookiesLabel',
  },
  {
    id: MENU_ITEMS_IDS.DISABLE_BROWSER_COOKIES_MENU_ITEM_ID,
    title: 'Desabilitar cookies no navegador',
    translateKey: 'menu.disableAllCookiesLabel',
  },
  {
    id: MENU_ITEMS_IDS.SERVICE_CHANNEL_MENU_ITEM_ID,
    title: 'Atendimento ao titular',
    translateKey: 'menu.serviceChannelLabel',
  },
]

const TEXT_FIELDS = {
  BANNER_TITLE: 'banner.title',
  BANNER_DESCRIPTION: 'banner.description',
  BUTTON_ACCEPT_ALL: 'button.acceptAll',
  BUTTON_REJECT: 'button.rejectAll',
  BUTTON_MANAGE_COOKIES: 'button.manageCookies',
  BUTTON_ACCEPT_ALL_MOBILE: 'button.acceptAllMobile',
  BUTTON_REJECT_MOBILE: 'button.rejectAllMobile',
  BUTTON_MANAGE_COOKIES_MOBILE: 'button.manageCookiesMobile',
  PRIVACY_PORTAL_LINK: 'privacyPortal.title',
}

const BUTTON_MOBILE_TEXT_MAX_LENGTH = 12

const TEXT_FIELDS_LEVEL_2 = {
  BANNER_LEVEL_2_TITLE: 'banner.secondLevelTitle',
  BUTTON_LEVEL_2_ACCEPT_ALL: 'button.acceptAllCookies',
  BUTTON_LEVEL_2_REJECT: 'button.rejectAllExceptNecessary',
  BUTTON_LEVEL_2_CONFIRM: 'button.confirmChoices',
  PRIVACY_LEVEL_2_PORTAL_LINK: 'privacyPortal.title',
  PRIVACY_LEVEL_2_DESCRIPTION: 'privacyPortal.description',
}

const ORDERED_TEXT_FIELDS_LEVEL_2 = [
  TEXT_FIELDS_LEVEL_2.BANNER_LEVEL_2_TITLE,
  TEXT_FIELDS_LEVEL_2.PRIVACY_LEVEL_2_DESCRIPTION,
  TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_REJECT,
  TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_CONFIRM,
  TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_ACCEPT_ALL,
]

const TEXT_FIELD_CONFIG_LEVEL_2 = {
  [TEXT_FIELDS_LEVEL_2.BANNER_LEVEL_2_TITLE]: {
    label: 'Título',
    multiline: false,
  },
  [TEXT_FIELDS_LEVEL_2.PRIVACY_LEVEL_2_DESCRIPTION]: {
    label: 'Descrição do canal de atendimento',
    multiline: true,
  },
  [TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_ACCEPT_ALL]: {
    label: 'Botão Permitir todos os cookies',
    multiline: false,
  },
  [TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_REJECT]: {
    label: 'Botão Rejeitar cookies não necessários',
    multiline: false,
  },
  [TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_CONFIRM]: {
    label: 'Botão Confirmar minhas escolhas',
    multiline: false,
  },
}

const ORDERED_TEXT_FIELDS = [
  TEXT_FIELDS.BANNER_TITLE,
  TEXT_FIELDS.PRIVACY_PORTAL_LINK,
  TEXT_FIELDS.BANNER_DESCRIPTION,
  TEXT_FIELDS.BUTTON_ACCEPT_ALL,
  TEXT_FIELDS.BUTTON_REJECT,
  TEXT_FIELDS.BUTTON_MANAGE_COOKIES,
]

const TEXT_FIELD_CONFIG = {
  [TEXT_FIELDS.BANNER_TITLE]: {
    label: 'Título',
    placeholderKey: TEXT_FIELDS.BANNER_TITLE,
    multiline: false,
  },
  [TEXT_FIELDS.PRIVACY_PORTAL_LINK]: {
    label: 'Atalho canal de atendimento ao titular de dados (somente texto)',
    placeholderKey: TEXT_FIELDS.PRIVACY_PORTAL_LINK,
    multiline: false,
  },
  [TEXT_FIELDS.BANNER_DESCRIPTION]: {
    label: 'Descrição',
    placeholderKey: TEXT_FIELDS.BANNER_DESCRIPTION,
    multiline: true,
  },
  [TEXT_FIELDS.BUTTON_ACCEPT_ALL]: {
    label: 'Botão Aceitar todos',
    placeholderKey: TEXT_FIELDS.BUTTON_ACCEPT_ALL,
    multiline: false,
    mobileField: TEXT_FIELDS.BUTTON_ACCEPT_ALL_MOBILE,
    maxLength: 16,
  },
  [TEXT_FIELDS.BUTTON_REJECT]: {
    label: 'Botão Rejeitar todos',
    placeholderKey: TEXT_FIELDS.BUTTON_REJECT,
    multiline: false,
    mobileField: TEXT_FIELDS.BUTTON_REJECT_MOBILE,
    maxLength: 16,
  },
  [TEXT_FIELDS.BUTTON_MANAGE_COOKIES]: {
    label: 'Botão Gerenciar cookies',
    placeholderKey: TEXT_FIELDS.BUTTON_MANAGE_COOKIES,
    multiline: false,
    mobileField: TEXT_FIELDS.BUTTON_MANAGE_COOKIES_MOBILE,
    maxLength: 20,
  },
}

const TEXT_FIELD_PLACEHOLDERS = {
  'pt-BR': {
    [TEXT_FIELDS.BANNER_TITLE]: 'Controle sua privacidade',
    [TEXT_FIELDS.PRIVACY_PORTAL_LINK]: 'Atendimento ao titular de dados',
    [TEXT_FIELDS.BANNER_DESCRIPTION]:
      'Para melhorar a sua experiência na plataforma e prover serviços personalizados, utilizamos cookies. Ao aceitar, você terá acesso a todas as funcionalidades do site. Se clicar em "Rejeitar todos", os cookies que não forem estritamente necessários serão desativados. Para escolher quais quer autorizar, clique em "Gerenciar cookies". Para maiores informações, consulte a nossa Política de Cookies.',
    [TEXT_FIELDS.BUTTON_ACCEPT_ALL]: 'Aceitar todos',
    [TEXT_FIELDS.BUTTON_REJECT]: 'Rejeitar todos',
    [TEXT_FIELDS.BUTTON_MANAGE_COOKIES]: 'Gerenciar cookies',
    [TEXT_FIELDS.BUTTON_ACCEPT_ALL_MOBILE]: 'Aceitar',
    [TEXT_FIELDS.BUTTON_REJECT_MOBILE]: 'Rejeitar',
    [TEXT_FIELDS.BUTTON_MANAGE_COOKIES_MOBILE]: 'Configurar',
    compact: {
      [TEXT_FIELDS.BANNER_DESCRIPTION]:
        "Usamos cookies para personalizar sua experiência. Aceite para ter acesso a todas as funções, rejeite os não essenciais ou personalize suas escolhas em 'Gerenciar cookies'.",
    },
  },
  'en-US': {
    [TEXT_FIELDS.BANNER_TITLE]: 'Control your privacy',
    [TEXT_FIELDS.PRIVACY_PORTAL_LINK]: 'DSAR',
    [TEXT_FIELDS.BANNER_DESCRIPTION]:
      'To enhance your experience on the platform and provide personalized services, we use cookies. By accepting, you will have access to all site features. If you click "Reject all", non-essential cookies will be disabled. To choose which ones to authorize, click "Manage cookies".',
    [TEXT_FIELDS.BUTTON_ACCEPT_ALL]: 'Accept all',
    [TEXT_FIELDS.BUTTON_REJECT]: 'Reject all',
    [TEXT_FIELDS.BUTTON_MANAGE_COOKIES]: 'Manage cookies',
    [TEXT_FIELDS.BUTTON_ACCEPT_ALL_MOBILE]: 'Accept',
    [TEXT_FIELDS.BUTTON_REJECT_MOBILE]: 'Reject',
    [TEXT_FIELDS.BUTTON_MANAGE_COOKIES_MOBILE]: 'Settings',
    compact: {
      [TEXT_FIELDS.BANNER_DESCRIPTION]:
        "We use cookies to personalize your experience. Accept to access all features, reject non-essential ones, or customize your choices in 'Manage cookies'.",
    },
  },
  'es-ES': {
    [TEXT_FIELDS.BANNER_TITLE]: 'Controle su privacidad',
    [TEXT_FIELDS.PRIVACY_PORTAL_LINK]: 'Atención al titular de datos',
    [TEXT_FIELDS.BANNER_DESCRIPTION]:
      'Para mejorar su experiencia en la plataforma y brindar servicios personalizados, utilizamos cookies. Al aceptar, tendrá acceso a todas las funcionalidades del sitio. Si hace clic en "Rechazar todos", las cookies que no sean estrictamente necesarias serán desactivadas. Para elegir cuáles autorizar, haga clic en "Gestionar cookies".',
    [TEXT_FIELDS.BUTTON_ACCEPT_ALL]: 'Aceptar todos',
    [TEXT_FIELDS.BUTTON_REJECT]: 'Rechazar todos',
    [TEXT_FIELDS.BUTTON_MANAGE_COOKIES]: 'Gestionar cookies',
    [TEXT_FIELDS.BUTTON_ACCEPT_ALL_MOBILE]: 'Aceptar',
    [TEXT_FIELDS.BUTTON_REJECT_MOBILE]: 'Rechazar',
    [TEXT_FIELDS.BUTTON_MANAGE_COOKIES_MOBILE]: 'Configurar',
    compact: {
      [TEXT_FIELDS.BANNER_DESCRIPTION]:
        "Usamos cookies para personalizar su experiencia. Acepte para acceder a todas las funciones, rechace las no esenciales o personalice sus opciones en 'Gestionar cookies'.",
    },
  },
}

const TEXT_FIELD_LVL_2_PLACEHOLDERS = {
  'pt-BR': {
    [TEXT_FIELDS_LEVEL_2.BANNER_LEVEL_2_TITLE]: 'Preferências de privacidade',
    [TEXT_FIELDS_LEVEL_2.BANNER_LEVEL_2_DESCRIPTION]:
      'Personalize suas preferências de cookies selecionando as categorias abaixo. Você pode permitir todos, rejeitar os não necessários ou confirmar apenas suas escolhas.',
    [TEXT_FIELDS_LEVEL_2.PRIVACY_LEVEL_2_PORTAL_LINK]:
      'Atendimento ao titular de dados',
    [TEXT_FIELDS_LEVEL_2.PRIVACY_LEVEL_2_DESCRIPTION]:
      'Nossa página do Canal de Comunicação é seu ponto de contato direto para questões relacionadas à LGPD. Aqui, você pode reportar preocupações, solicitar informações sobre seus dados pessoais e esclarecer dúvidas sobre a proteção da sua privacidade. Estamos prontos para ouvir e responder às suas necessidades de forma segura e confidencial. Sua privacidade é nossa prioridade.',
    [TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_ACCEPT_ALL]:
      'Permitir todos os cookies',
    [TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_REJECT]:
      'Rejeitar cookies não necessários',
    [TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_CONFIRM]: 'Confirmar minhas escolhas',
  },
  'en-US': {
    [TEXT_FIELDS_LEVEL_2.BANNER_LEVEL_2_TITLE]: 'Privacy preferences',
    [TEXT_FIELDS_LEVEL_2.BANNER_LEVEL_2_DESCRIPTION]:
      'Customize your cookie preferences by selecting the categories below. You can allow all, reject non-essential ones, or confirm only your selections.',
    [TEXT_FIELDS_LEVEL_2.PRIVACY_LEVEL_2_PORTAL_LINK]: 'Service Channel',
    [TEXT_FIELDS_LEVEL_2.PRIVACY_LEVEL_2_DESCRIPTION]:
      'Our DSAR page allows you to request access to your personal data, correct inaccuracies, or request deletion in accordance with data protection laws. This secure channel ensures your data privacy rights are respected and handled with confidentiality.',
    [TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_ACCEPT_ALL]: 'Allow all cookies',
    [TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_REJECT]: 'Reject non-essential cookies',
    [TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_CONFIRM]: 'Confirm my choices',
  },
  'es-ES': {
    [TEXT_FIELDS_LEVEL_2.BANNER_LEVEL_2_TITLE]: 'Preferencias de privacidad',
    [TEXT_FIELDS_LEVEL_2.BANNER_LEVEL_2_DESCRIPTION]:
      'Personaliza tus preferencias de cookies seleccionando las categorías abajo. Puedes permitir todas, rechazar las no esenciales o confirmar solo tus elecciones.',
    [TEXT_FIELDS_LEVEL_2.PRIVACY_LEVEL_2_PORTAL_LINK]: 'Canal de atención',
    [TEXT_FIELDS_LEVEL_2.PRIVACY_LEVEL_2_DESCRIPTION]:
      'Nuestra página del Canal de Atención es su punto de contacto directo para temas relacionados con la privacidad de datos. Aquí puede reportar inquietudes, solicitar información sobre sus datos personales y aclarar dudas sobre la protección de su privacidad. Estamos listos para escuchar y responder a sus necesidades de manera segura y confidencial. Su privacidad es nuestra prioridad.',
    [TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_ACCEPT_ALL]:
      'Permitir todas las cookies',
    [TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_REJECT]:
      'Rechazar cookies no esenciales',
    [TEXT_FIELDS_LEVEL_2.BUTTON_LEVEL_2_CONFIRM]: 'Confirmar mis elecciones',
  },
}

const bannerTextsOverrides = {
  BUTTON_MOBILE_TEXT_MAX_LENGTH,
  COOKIE_MENU_ITEMS_OBJECT,
  MENU_ITEMS_IDS,
  ORDERED_TEXT_FIELDS,
  TEXT_FIELD_CONFIG,
  TEXT_FIELD_PLACEHOLDERS,
  TEXT_FIELD_LVL_2_PLACEHOLDERS,
  ORDERED_TEXT_FIELDS_LEVEL_2,
  TEXT_FIELD_CONFIG_LEVEL_2,
  TEXT_FIELDS_LEVEL_2,
  TEXT_FIELDS,
}

export default bannerTextsOverrides
